export const passwordRegex = {
  length: /.{10,}/, // Minimum 10 characters
  lowercase: /[a-z]/, // At least one lowercase letter
  uppercase: /[A-Z]/, // At least one uppercase letter
  number: /[0-9]/, // At least one number
  specialChar: /[!@#$%^&*(),.?":{}|<>]/, // At least one special character
};
